const commonOptions = {
    credentials: 'include',
    headers: {
        'Content-Type': 'application/json',
    }
}

export { commonOptions }